import { useEffect, useRef } from 'react';

export default function HintPanel({ hints, currentHintNumber, timeLeft }) {
  const listRef = useRef(null);

  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight;
    }
  }, [hints.length]);

  const progress = ((30 - timeLeft) / 30) * 100;

  return (
    <div style={styles.wrapper}>
      <div style={styles.header}>
        <span style={styles.label}>💡 Hints</span>
        <span style={styles.counter}>{hints.length} / 5</span>
      </div>

      {/* Next hint timer bar */}
      {currentHintNumber < 5 && (
        <div style={styles.timerBarWrapper}>
          <div style={{ ...styles.timerBar, width: `${progress}%` }} />
          <span style={styles.timerText}>
            Next hint in {timeLeft}s
          </span>
        </div>
      )}

      {/* Hints list */}
      <div style={styles.list} ref={listRef}>
        {hints.map((hint, i) => (
          <div
            key={i}
            style={{
              ...styles.hintItem,
              animation: `slideIn 0.4s ease ${i === hints.length - 1 ? '0s' : '0s'} both`,
              borderLeft: i === hints.length - 1
                ? '3px solid #6366f1'
                : '3px solid rgba(255,255,255,0.08)',
            }}
          >
            <span style={styles.hintNum}>#{i + 1}</span>
            <span style={styles.hintText}>{hint}</span>
          </div>
        ))}

        {/* Locked future hints */}
        {Array.from({ length: 5 - hints.length }).map((_, i) => (
          <div key={`locked-${i}`} style={styles.lockedHint}>
            <span style={styles.hintNum}>#{hints.length + i + 1}</span>
            <span style={styles.lockedText}>🔒 Coming soon...</span>
          </div>
        ))}
      </div>

      <style>{`
        @keyframes slideIn {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}

const styles = {
  wrapper: {
    display: 'flex', flexDirection: 'column', gap: '8px',
    background: 'rgba(255,255,255,0.03)',
    border: '1px solid rgba(255,255,255,0.07)',
    borderRadius: '16px', padding: '16px', flex: 1,
  },
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    marginBottom: '4px',
  },
  label: { fontSize: '13px', color: 'rgba(255,255,255,0.5)', fontWeight: '600' },
  counter: {
    fontSize: '12px', color: '#6366f1', fontWeight: '700',
    background: 'rgba(99,102,241,0.15)', padding: '2px 8px', borderRadius: '8px',
  },
  timerBarWrapper: {
    position: 'relative', height: '4px',
    background: 'rgba(255,255,255,0.06)', borderRadius: '4px', overflow: 'hidden',
    marginBottom: '4px',
  },
  timerBar: {
    position: 'absolute', left: 0, top: 0, height: '100%',
    background: 'linear-gradient(90deg, #6366f1, #8b5cf6)',
    borderRadius: '4px', transition: 'width 1s linear',
  },
  timerText: {
    position: 'absolute', right: 0, top: '6px',
    fontSize: '10px', color: 'rgba(255,255,255,0.35)',
  },
  list: { display: 'flex', flexDirection: 'column', gap: '6px', overflowY: 'auto', maxHeight: '300px' },
  hintItem: {
    display: 'flex', gap: '10px', padding: '10px 12px',
    background: 'rgba(255,255,255,0.04)',
    borderRadius: '10px',
    alignItems: 'flex-start',
  },
  hintNum: {
    fontSize: '11px', fontWeight: '800', color: '#6366f1',
    minWidth: '24px', paddingTop: '2px',
  },
  hintText: { fontSize: '13px', color: 'rgba(255,255,255,0.85)', lineHeight: '1.5' },
  lockedHint: {
    display: 'flex', gap: '10px', padding: '10px 12px',
    background: 'rgba(255,255,255,0.01)',
    borderRadius: '10px', borderLeft: '3px solid rgba(255,255,255,0.04)',
    alignItems: 'center',
  },
  lockedText: { fontSize: '13px', color: 'rgba(255,255,255,0.2)' },
};